// Copyright (c) 2025 Just Feasible Solutions LLC. All rights reserved.
// This file is part of the Just Feasible Solutions application.
// Unauthorized copying, distribution, or modification of this file is prohibited.
// For license information, contact the author.

import React from 'react';

const Accessibility = () => (
  <div style={{ maxWidth: 900, margin: '0 auto', padding: '2rem' }}>
    <h1>Accessibility</h1>
    <p>
      Just Feasible Solutions LLC is committed to making Just Feasible Solutions accessible to everyone, including people with disabilities. We strive to follow best practices and standards as defined by the Web Content Accessibility Guidelines (WCAG) and other relevant regulations.
    </p>
    <h2>Our Accessibility Commitment</h2>
    <ul>
      <li>We design and develop our application to be usable with screen readers and assistive technologies.</li>
      <li>We use clear, high-contrast text and scalable fonts for readability.</li>
      <li>We provide keyboard navigation and accessible forms wherever possible.</li>
      <li>We regularly review and test our site for accessibility improvements.</li>
    </ul>
    <h2>Feedback & Assistance</h2>
    <p>
      If you encounter any accessibility barriers or have suggestions for improvement, please contact us at <a href="mailto:support@justfeasible.com">support@justfeasible.com</a>. We welcome your feedback and will do our best to address your concerns promptly.
    </p>
    <p style={{ marginTop: 32, color: '#888', fontSize: '0.97rem' }}>
      &copy; 2025 Just Feasible Solutions LLC. All rights reserved.
    </p>
  </div>
);

export default Accessibility;
